import { View } from 'react-native';
const ScreenContainer = View;
export default ScreenContainer;
//# sourceMappingURL=ScreenContainer.web.js.map